var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"back"}),_c('div',{staticClass:"main"},[_c('T_Main')],1),_c('div',{staticClass:"footer"},[_c('T_footer2',{attrs:{"inviter_id":_vm.inviterId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }